
















import {Component, Vue, Prop} from 'vue-property-decorator'
import {Getter, Mutation, Action} from 'vuex-class'
import ListItem from '@/components/common/ListItem.vue'
import {InventoryItem as InventoryItemInterface, ItemType, Room} from '@/store/types'

@Component({
  components: {
    ListItem,
  },
})
export default class InventoryItem extends Vue {
  @Prop({type: Object, required: true}) public item!: ItemType
  @Getter('activeRoom') public activeRoom!: Room
  @Mutation('setInventoryItemListOverlay') public setInventoryItemListOverlay!: any
  @Mutation('setInventoryNewItemOverlay') public setInventoryNewItemOverlay!: any
  @Mutation('setAddedItem') public setAddedItem!: any
  @Mutation('setActiveItemType') public setActiveItemType!: any
  @Action('addRoomItem') public addRoomItem!: any
  @Action('openInventoryAddedItem') public openInventoryAddedItem!: any
  @Action('focusSearch') public focusSearch!: any

  public add() {
    if (this.item.custom !== undefined && this.item.custom) {
      this.showSingleItem(this.item)
    } else {
      this.addItem()
    }
  }
  public addItem() {
    const data: any = {
      inventory_id: this.item.id,
      lead_room_id: this.activeRoom.id,
      quantity: 1,
    }
    this.addRoomItem(data)
    this.openInventoryAddedItem()
    this.setAddedItem(this.item)
  }
  public showSingleItem(itemType: ItemType) {
    this.setActiveItemType(itemType)
    this.setInventoryNewItemOverlay(true)
  }
}
